// Type definitions for OrderDetails modal components

export interface TransmissionEvent {
  id: string;
  ofId: string;
  ofIdType: string;
  to: string;
  toType: string;
  newState: string;
  isDeliveryEvent: boolean;
  isFailureEvent: boolean;
  timestamp: string;
  metaData?: string | null;
}

export interface OrderProduct {
  id: string;
  externalId?: string | null;
  name: string;
  unit: string;
  amount: number;
}

export interface OrderUser {
  id: string;
  name?: string | null;
  phone?: string | null;
}

export interface OrderBuyer {
  id: string | null; // not returned by the GraphQL fragment
  name?: string | null;
  fullAddress?: string | null;
}

export interface OrderSupplier {
  id: string | null; // not returned by the GraphQL fragment
  name?: string | null;
}

export interface OrderChat {
  id: string;
  deliveryAddress?: string | null;
}

// Values must match the OrderCreatedContext enum in the AppSync schema
// verbatim — AppSync returns the enum literal, and it is camelCase.
export enum OrderCreatedContext {
  ChocoApp = 'chocoApp',
  ChocoAi = 'chocoAi',
  ChocoWeb = 'chocoWeb',
  TeamOrder = 'teamOrder',
  WhiteLabelApp = 'whiteLabelApp',
  WhiteLabelWeb = 'whiteLabelWeb',
  VoiceAgent = 'voiceAgent',
  IntegrationPublicApi = 'integrationPublicApi',
}

export interface OrderDetails {
  id: string;
  referenceId: string;
  status: string;
  /** Epoch MILLISECONDS. */
  createdAt: number;
  /**
   * Epoch SECONDS, a different unit to `createdAt` despite both being
   * `AWSTimestamp` on the wire. Parsing it as an ISO string silently dropped
   * the delivery date on every order.
   */
  deliveryDate?: number | null;
  body?: string | null;
  pdf?: string | null;
  isTest?: boolean | null;
  createdContext?: OrderCreatedContext | null;
  user?: OrderUser | null;
  buyer?: OrderBuyer | null;
  supplier?: OrderSupplier | null;
  chat?: OrderChat | null;
  products: OrderProduct[];
}

export interface OrderDetailsModalProps {
  orderId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export interface HeaderProps {
  order: OrderDetails | null;
  isLoading: boolean;
}

export interface InternalReportingProps {
  orderId: string;
  isTest: boolean;
}

export interface TransmissionEventTableProps {
  isLoading: boolean;
  transmissionEvents: TransmissionEvent[];
  orderCreatedAt?: number;
}

export interface TransmissionEventChannelsProps {
  transmissionEvents: TransmissionEvent[];
  orderCreatedAt?: number;
}

export interface TransmissionEventChannelProps {
  channelEvents: TransmissionEvent[];
  orderCreatedAt?: number;
}

export interface TransmissionEventRowProps {
  transmissionEvent: TransmissionEvent;
  orderCreatedAt?: number;
}

export interface ProductsTableProps {
  isLoading: boolean;
  products: OrderProduct[];
}
